import { render } from "./PostPotentialChart.vue?vue&type=template&id=244af492&scoped=true"
import script from "./PostPotentialChart.vue?vue&type=script&lang=js"
export * from "./PostPotentialChart.vue?vue&type=script&lang=js"

import "./PostPotentialChart.vue?vue&type=style&index=0&id=244af492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244af492"]])

export default __exports__